/**
 * PIEFallbackBadge — small honesty-marker badge rendered next to AI
 * surfaces when the response was assembled from the deterministic
 * fallback (no LLM round-trip). Pairs with the chrome-level health
 * pill: the pill says "AI offline at the system level"; this badge
 * says "this specific sentence is built-in, not AI-generated".
 *
 * Reusable across Insights / Coach / Validate so the fallback story
 * stays consistent.
 */
import React from 'react';
import { Cog } from 'lucide-react';

export default function PIEFallbackBadge({ label = 'Built-in suggestion' }) {
  return (
    <span
      data-testid="pie-fallback-badge"
      title="AI Coach is offline. This sentence is generated from your numbers using the built-in formula, not from Claude."
      style={{
        display: 'inline-flex', alignItems: 'center', gap: 4,
        marginTop: 8, padding: '3px 8px', borderRadius: 999,
        background: 'rgba(245, 158, 11, 0.10)',
        border: '1px solid rgba(245, 158, 11, 0.35)',
        color: '#92400E',
        fontSize: 10, fontWeight: 600, letterSpacing: 0.3,
        textTransform: 'uppercase',
      }}
    >
      <Cog size={10} aria-hidden />
      {label}
    </span>
  );
}
